'use strict';

angular.module('shiftTraderApp')
    .directive('saIntervalInformationArea', function (WorkPeriodStore) {
      return {
        templateUrl: 'views/directives/saIntervalInformationArea.html',
        restrict: 'A',
        scope: {
          intervalObj: '=saIntervalInformationArea',
          ctrl: '=',
          department: '='
        },
        link: function (scope) {
          var checkPositionIds = !_.isUndefined(scope.department);
          var departmentPositionIds = null;

          if (checkPositionIds) {
            departmentPositionIds = _.pluck(scope.department.positions, 'id');
          }

          var currentDate = scope.ctrl.getCurrentDate();
          var startTime = moment(currentDate).subtract(6, 'hours');
          var endTime = moment(currentDate).add(30, 'hours');

          scope.intervalTwix = moment(startTime).add(scope.intervalObj.interval[0], 'minutes').
              twix(moment(startTime).add(scope.intervalObj.interval[1], 'minutes'));

          scope.intervalTwixLengthInHours = scope.intervalTwix.length('minutes') / 60.0;

          WorkPeriodStore.getWorkPeriodsBetween(startTime, endTime)
              .then(function(wps) {
                scope.relevantWorkPeriods = _.where(wps, function(wp) {
                  return (!checkPositionIds || _.contains(departmentPositionIds, wp.position_id)) &&
                      wp.range_twix.overlaps(scope.intervalTwix) &&
                      Math.abs(wp.range_twix.intersection(scope.intervalTwix).length('minutes') > 0) &&
                      wp.active;
                });

                calculateStats();
              });

          var calculateStats = function() {
            scope.costOfInterval = _.reduce(_.map(scope.relevantWorkPeriods, function(wp) {
              return wp.hourly_wage * wp.range_twix.intersection(scope.intervalTwix).length('minutes') / 60.0;
            }), function(accum, val) {
              return accum + val;
            }, 0);

            scope.averageHourlyCost = scope.costOfInterval / scope.intervalObj.count / scope.intervalTwixLengthInHours;

            scope.numberOfShifts = scope.relevantWorkPeriods.length;
          };

        }
      }
    });
